var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.filteredPointList),function(point,index){return [_c('MyMarker',{key:index,attrs:{"point":point,"has-edit-permission":_vm.hasEditPermission}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }